import React, { useState, useEffect } from 'react'
import {
  Input,
  Form,
  FormGroup,
  ControlLabel,
  Grid,
  Row,
  Col,
  RadioGroup,
  Radio,
  SelectPicker,
  InputGroup,
  Uploader,
  Icon,
  Cascader,
  DatePicker,
} from 'rsuite'
import classNames from 'classnames'
import moment from 'moment'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import { isValidators, isRequired, getMaxLengthData } from '../../../utils/ValidatorUtils'
import AppContext from '../../../context/AppContext'
import './styles.less'
import { verificationPerson } from '../../../redux/actions/verification'
import { isEmpty } from 'lodash-es'
import { DATE_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'
import InputForm from '../input/InputForm'
import { locationZipcode } from '../../location/Location'
import OverlayLoader from '../../OverlayLoader/OverlayLoader'

export default function WorkingGroupForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  getValues,
  setValue,
  clearErrors,
  selectedIndex,
}) {
  const { theme } = React.useContext(AppContext)
  const [schema, setSchema] = useState(_schema)
  const [showOtherNationality, setShowOtherNationality] = useState(schema.nationality?.value == 2)
  const [location, setLocation] = useState([])
  const [editIndex, setEditIndex] = useState(selectedIndex)
  const [isLoadingVerification, setIsLoadingVerification] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    handleLocation()
  }, [])

  const handleLocation = async () => {
    setIsLoading(true)
    const location = await locationZipcode()
    setLocation(location)
    setIsLoading(false)
  }

  const onClickVerificationPerson = async () => {
    const idNumber = getValues(schema.idNumber.name)
    if (!idNumber) {
      return
    }
    setIsLoadingVerification(true)
    let personData
    try {
      personData = await verificationPerson(idNumber)
    } catch (e) {}
    setIsLoadingVerification(false)
    if (personData) {
      setValueVerification(personData)
    }
  }

  const setValueVerification = (value) => {
    if (value) {
      //setValue('id', value.personId)
      setValue(schema.idNumber.name, value.idcard)
      setValue(schema.honorific.name, value.masterPreNameId)
      setValue(schema.firstName.name, value.firstName)
      setValue(schema.lastName.name, value.lastName)
      setValue(schema.nationality.name, value.nationality)
      setValue('nationalityInputOther', value.nationalityOther)
      setValue(schema.mobile.name, value.mobileNumber)
      setValue(schema.telephone.name, value.telephoneNumber)
      setValue(schema.fax.name, value.fax)
      setValue(schema.email.name, value.email)
      setValue('idCard', value.idCard || undefined)
      setValue(schema.dateOfBirth.name, value.dateOfBirth)
      setValue(schema.lineId.name, value.lineId)
      clearErrors()
    }
  }

  const uploadFileColSize = () => {
    if (schema.idCard && schema.attorneyFile) {
      return 12
    }
    return 24
  }

  return (
    <>
      <Grid fluid>
        <Form fluid className="personal-basic-info-form">
          <Controller
            key={'selectedIndex'}
            name={'selectedIndex'}
            control={control}
            defaultValue={editIndex}
          />
          <FormGroup>
            <Row>
              <Col xs={24} sm={24} md={14} lg={14}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.idNumber.validators) && 'required'
                  )}
                >
                  {schema.idNumber.label}
                </ControlLabel>
                <ErrorMessage error={errors.idNumber} />
                <InputGroup style={{ width: '100%' }}>
                  <Controller
                    name={schema.idNumber.name}
                    control={control}
                    defaultValue={schema.idNumber.value || ''}
                    rules={isValidators(schema.idNumber.validators)}
                    render={(props) => {
                      return (
                        <Input
                          placeholder={schema.idNumber.label}
                          value={props.value}
                          maxLength={getMaxLengthData(schema.idNumber.validators).value}
                          onChange={(value, e) => {
                            if (value) {
                              value = value?.replace(' ', '')
                            }
                            if (isNaN(value)) {
                              return
                            }
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                  {/* <InputGroup.Button
                    onClick={() => onClickVerificationPerson()}
                    disabled={isLoadingVerification}
                  >
                    ตรวจสอบ
                  </InputGroup.Button> */}
                </InputGroup>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col xs={24} sm={8} md={6} lg={6}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.honorific.validators) && 'required'
                  )}
                >
                  {schema.honorific.label}
                </ControlLabel>
                <ErrorMessage error={errors.honorific} />
                <Controller
                  name={schema.honorific.name}
                  control={control}
                  defaultValue={schema.honorific.value || ''}
                  rules={isValidators(schema.honorific.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={schema.honorific.options}
                        value={props.value}
                        style={{ width: '100%' }}
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={8} md={6} lg={6}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.firstName.validators) && 'required'
                  )}
                >
                  {schema.firstName.label}
                </ControlLabel>
                <ErrorMessage error={errors.firstName} />
                <Input
                  placeholder={schema.firstName.label}
                  defaultValue={schema.firstName.value || ''}
                  name={schema.firstName.name}
                  inputRef={register(isValidators(schema.firstName.validators))}
                />
              </Col>
              <Col xs={24} sm={8} md={8} lg={8}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.lastName.validators) && 'required'
                  )}
                >
                  {schema.lastName.label}
                </ControlLabel>
                <ErrorMessage error={errors.lastName} />
                <Input
                  placeholder={schema.lastName.label}
                  defaultValue={schema.lastName.value || ''}
                  name={schema.lastName.name}
                  inputRef={register(isValidators(schema.lastName.validators))}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.dateOfBirth.validators) && 'required'
                  )}
                >
                  {schema.dateOfBirth.label}
                </ControlLabel>
                <ErrorMessage error={errors.dateOfBirth} />
                <Controller
                  name={schema.dateOfBirth.name}
                  control={control}
                  defaultValue={
                    schema.dateOfBirth.value
                      ? moment(schema.dateOfBirth.value, DATE_FORMAT).toDate()
                      : null
                  }
                  rules={isValidators(schema.dateOfBirth.validators)}
                  render={(props) => {
                    return (
                      <DatePicker
                        format="DD/MM/YYYY"
                        locale={LOCAL_DAY_TH}
                        block
                        placement="auto"
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.nationality.validators) && 'required'
                  )}
                >
                  {schema.nationality.label}
                </ControlLabel>
                <ErrorMessage error={errors.nationality || errors.nationalityInputOther} />
                <Controller
                  name={schema.nationality.name}
                  control={control}
                  defaultValue={schema.nationality.value || 1}
                  rules={isValidators(schema.nationality.validators)}
                  render={(props) => {
                    return (
                      <RadioGroup
                        name="radioList"
                        inline
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          if (value == 2) {
                            setShowOtherNationality(true)
                          } else {
                            setShowOtherNationality(false)
                          }
                        }}
                      >
                        {schema.nationality?.options &&
                          schema.nationality.options.map((item) => (
                            <Radio key={item.value} value={item.value}>
                              {item.label}
                            </Radio>
                          ))}
                        {/* <Radio value={2}>อื่นๆ</Radio> */}
                      </RadioGroup>
                    )
                  }}
                />
              </Col>
              {showOtherNationality && (
                <Col xs={16} sm={16} md={16} lg={16}>
                  <Input
                    name={'nationalityInputOther'}
                    placeholder={schema.nationality.inputOther.label}
                    defaultValue={schema.nationality.inputOther.value || ''}
                    inputRef={register(isValidators(schema.nationality?.inputOther?.validators))}
                  />
                </Col>
              )}
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col xs={24} sm={8} md={8} lg={8}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.telephone.validators) && 'required'
                  )}
                >
                  {schema.telephone.label}
                </ControlLabel>
                <ErrorMessage error={errors.telephone} />
                <Controller
                  name={schema.telephone.name}
                  control={control}
                  defaultValue={schema.telephone.value || ''}
                  rules={isValidators(schema.telephone.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={schema.telephone.label}
                        value={props.value}
                        maxLength={getMaxLengthData(schema.telephone.validators).value}
                        onChange={(value, e) => {
                          if (isNaN(value)) {
                            return
                          }
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={8} md={8} lg={8}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.mobile.validators) && 'required'
                  )}
                >
                  {schema.mobile.label}
                </ControlLabel>
                <ErrorMessage error={errors.mobile} />
                <Controller
                  name={schema.mobile.name}
                  control={control}
                  defaultValue={schema.mobile.value || ''}
                  rules={isValidators(schema.mobile.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={schema.mobile.label}
                        value={props.value}
                        maxLength={getMaxLengthData(schema.mobile.validators).value}
                        onChange={(value, e) => {
                          if (isNaN(value)) {
                            return
                          }
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={8} md={8} lg={8}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.fax.validators) && 'required'
                  )}
                >
                  {schema.fax.label}
                </ControlLabel>
                <ErrorMessage error={errors.fax} />
                <Controller
                  name={schema.fax.name}
                  control={control}
                  defaultValue={schema.fax.value || ''}
                  rules={isValidators(schema.fax.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={schema.fax.label}
                        value={props.value}
                        maxLength={getMaxLengthData(schema.fax.validators).value}
                        onChange={(value, e) => {
                          if (isNaN(value)) {
                            return
                          }
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={8} md={8} lg={8} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.email.validators) && 'required'
                  )}
                >
                  {schema.email.label}
                </ControlLabel>
                <ErrorMessage error={errors.email} />
                <Input
                  placeholder={schema.email.label}
                  defaultValue={schema.email.value || ''}
                  name={schema.email.name}
                  inputRef={register(isValidators(schema.email.validators))}
                />
              </Col>
              <Col xs={24} sm={8} md={8} lg={8} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.lineId.validators) && 'required'
                  )}
                >
                  {schema.lineId.label}
                </ControlLabel>
                <ErrorMessage error={errors.lineId} />
                <Input
                  placeholder={schema.lineId.label}
                  defaultValue={schema.lineId.value}
                  name={schema.lineId.name}
                  inputRef={register(isValidators(schema.lineId.validators))}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row style={{ justifyItems: 'center' }}>
              {schema.idCard && (
                <>
                  <Col xs={24} sm={24} md={uploadFileColSize()} lg={uploadFileColSize()}>
                    <ControlLabel
                      className={classNames(
                        'style-text-lable',
                        isRequired(schema.idCard.validators) && 'required'
                      )}
                    >
                      {schema.idCard.label}
                    </ControlLabel>
                    <ErrorMessage error={errors.idCard} />
                    <Controller
                      name={'idCard'}
                      control={control}
                      defaultValue={
                        !isEmpty(schema.idCard.value) ? [schema.idCard.value] : undefined
                      }
                      rules={isValidators(schema.idCard.validators)}
                      render={(props) => {
                        return (
                          <Uploader
                            draggable
                            autoUpload={false}
                            fileList={props.value || []}
                            onChange={(fileList) => {
                              if (isEmpty(fileList)) {
                                props.onChange(undefined)
                              } else {
                                let files = []
                                files.push(fileList[fileList.length - 1])
                                props.onChange(files)
                              }
                            }}
                          >
                            <div>
                              <div className={classNames('uploader', `${theme[0]}-background`)}>
                                <Icon size="4x" icon="upload2" />
                                <small className="uploder__text">
                                  <span style={{ wordBreak: 'break-word' }}>
                                    คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                                  </span>
                                </small>
                              </div>
                            </div>
                          </Uploader>
                        )
                      }}
                    />
                  </Col>
                </>
              )}
              {schema.attorneyFile && (
                <>
                  <Col xs={24} sm={24} md={uploadFileColSize()} lg={uploadFileColSize()}>
                    <ControlLabel
                      className={classNames(
                        'style-text-lable',
                        isRequired(schema.attorneyFile.validators) && 'required'
                      )}
                    >
                      {schema.attorneyFile.label}
                    </ControlLabel>
                    <ErrorMessage error={errors.attorneyFile} />
                    <Controller
                      name={'attorneyFile'}
                      control={control}
                      defaultValue={
                        !isEmpty(schema.attorneyFile.value)
                          ? [schema.attorneyFile.value]
                          : undefined
                      }
                      rules={isValidators(schema.attorneyFile.validators)}
                      render={(props) => {
                        return (
                          <Uploader
                            draggable
                            autoUpload={false}
                            fileList={props.value || []}
                            onChange={(fileList) => {
                              if (isEmpty(fileList)) {
                                props.onChange(undefined)
                              } else {
                                let files = []
                                files.push(fileList[fileList.length - 1])
                                props.onChange(files)
                              }
                            }}
                          >
                            <div>
                              <div className={classNames('uploader', `${theme[0]}-background`)}>
                                <Icon size="4x" icon="upload2" />
                                <small className="uploder__text">
                                  <span style={{ wordBreak: 'break-word' }}>
                                    คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                                  </span>
                                </small>
                              </div>
                            </div>
                          </Uploader>
                        )
                      }}
                    />
                  </Col>
                </>
              )}
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col xs={24} sm={24} md={18} lg={18}>
                <ControlLabel
                  className={classNames(isRequired(schema.buildingName.validators) && 'required')}
                >
                  {schema.buildingName.label}
                </ControlLabel>
                <ErrorMessage error={errors.buildingName} />
                <Input
                  placeholder={schema.buildingName.label}
                  defaultValue={schema.buildingName.value || ''}
                  name={schema.buildingName.name}
                  inputRef={register(isValidators(schema.buildingName.validators))}
                />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6}>
                <ControlLabel
                  className={classNames(isRequired(schema.roomNumber.validators) && 'required')}
                >
                  {schema.roomNumber.label}
                </ControlLabel>
                <ErrorMessage error={errors.roomNumber} />
                <Input
                  placeholder={schema.roomNumber.label}
                  defaultValue={schema.roomNumber.value || ''}
                  name={schema.roomNumber.name}
                  inputRef={register(isValidators(schema.roomNumber.validators))}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col xs={24} sm={24} md={5} lg={5}>
                <ControlLabel
                  className={classNames(isRequired(schema.houseNumber.validators) && 'required')}
                >
                  {schema.houseNumber.label}
                </ControlLabel>
                <ErrorMessage error={errors.houseNumber} />
                <Input
                  placeholder={schema.houseNumber.label}
                  defaultValue={schema.houseNumber.value || ''}
                  name={schema.houseNumber.name}
                  inputRef={register(isValidators(schema.houseNumber.validators))}
                />
              </Col>
              <Col xs={24} sm={24} md={3} lg={3}>
                <ControlLabel
                  className={classNames(isRequired(schema.villageNumber.validators) && 'required')}
                >
                  {schema.villageNumber.label}
                </ControlLabel>
                <ErrorMessage error={errors.villageNumber} />
                <Input
                  placeholder={schema.villageNumber.label}
                  defaultValue={schema.villageNumber.value || ''}
                  name={schema.villageNumber.name}
                  inputRef={register(isValidators(schema.villageNumber.validators))}
                />
              </Col>
              <Col xs={24} sm={24} md={8} lg={8}>
                <ControlLabel
                  className={classNames(isRequired(schema.lane.validators) && 'required')}
                >
                  {schema.lane.label}
                </ControlLabel>
                <ErrorMessage error={errors.lane} />
                <Input
                  placeholder={schema.lane.label}
                  defaultValue={schema.lane.value || ''}
                  name={schema.lane.name}
                  inputRef={register(isValidators(schema.lane.validators))}
                />
              </Col>
              <Col xs={24} sm={24} md={8} lg={8}>
                <ControlLabel
                  className={classNames(isRequired(schema.villageName.validators) && 'required')}
                >
                  {schema.villageName.label}
                </ControlLabel>
                <ErrorMessage error={errors.villageName} />
                <Input
                  placeholder={schema.villageName.label}
                  defaultValue={schema.villageName.value || ''}
                  name={schema.villageName.name}
                  inputRef={register(isValidators(schema.villageName.validators))}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col xs={24} sm={24} md={8} lg={8}>
                <ControlLabel
                  className={classNames(isRequired(schema.road.validators) && 'required')}
                >
                  {schema.road.label}
                </ControlLabel>
                <ErrorMessage error={errors.road} />
                <Input
                  placeholder={schema.road.label}
                  defaultValue={schema.road.value || ''}
                  name={schema.road.name}
                  inputRef={register(isValidators(schema.road.validators))}
                />
              </Col>
              <Col xs={24} sm={24} md={16} lg={16}>
                <ControlLabel
                  className={classNames(isRequired(schema.location.validators) && 'required')}
                >
                  {schema.location.label}
                </ControlLabel>
                <ErrorMessage error={errors.location} />
                <Controller
                  name={schema.location.name}
                  control={control}
                  defaultValue={schema.location.value || ''}
                  rules={isValidators(schema.location.validators)}
                  render={(props) => {
                    return (
                      <Cascader
                        block
                        menuWidth={180}
                        data={location}
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                        placeholder={schema.location.label}
                      />
                      // <LocationDropdown
                      //   placeholder={schema.location.label}
                      //   value={props.value}
                      //   location={location}
                      //   onChange={(value) => {
                      //     props.onChange(value)
                      //   }}
                      // />
                    )
                  }}
                />
              </Col>
            </Row>
          </FormGroup>
          {schema.projectPosition && (
            <FormGroup>
              <Row>
                <Col xs={24} sm={24} md={8} lg={8} style={{ width: 150, marginTop: 7 }}>
                  <ControlLabel
                    className={classNames(
                      isRequired(schema.projectPosition.validators) && 'required'
                    )}
                  >
                    {schema.projectPosition.label}
                  </ControlLabel>
                </Col>
              </Row>
              <Row>
                <Col xs={24} sm={24} md={8} lg={8}>
                  <ErrorMessage error={errors.projectPosition} />
                  <Input
                    placeholder={schema.projectPosition.label}
                    defaultValue={schema.projectPosition.value || ''}
                    name={schema.projectPosition.name}
                    inputRef={register(isValidators(schema.projectPosition.validators))}
                  />
                </Col>
              </Row>
            </FormGroup>
          )}
          {schema.positionExperience && (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <InputForm
                  schema={schema.positionExperience}
                  rows={3}
                  componentClass="textarea"
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />

                {/* <ControlLabel
                    className={classNames(
                      isRequired(schema.positionExperience.validators) && 'required'
                    )}
                  >
                    {schema.positionExperience.label}
                  </ControlLabel>
                  <ErrorMessage error={errors.positionExperience} />

                  <Input
                    style={{ minWidth: 198 }}
                    placeholder={schema.positionExperience.label}
                    defaultValue={schema.positionExperience.value || ''}
                    name={schema.positionExperience.name}
                    componentClass="textarea"
                    inputRef={register(isValidators(schema.positionExperience.validators))}
                  /> */}
              </Col>
            </Row>
          )}
          {isLoading && <OverlayLoader />}
        </Form>
      </Grid>
    </>
  )
}
